module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_02@2x-73d73dab0cc102b5afe5f13f3a7df557.jpg";